import React, { useEffect, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import Button from '../../../shared/components/ui/Button';
import { updateBuilderCommission } from '../../services/api/implementation/impl';

const EditBuilderCommission = ({ builder, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    plot_commission_charge: '',
    unit_commission_charge: ''
  });

  useEffect(() => {
    if (!builder) return;
    setFormData({
      plot_commission_charge: builder.plot_commission_charge ?? '',
      unit_commission_charge: builder.unit_commission_charge ?? ''
    });
  }, [builder]);

  const { mutate: saveCommission, isLoading } = useMutation({
    mutationFn: (payload) => updateBuilderCommission(builder.builder_id, payload),
    onSuccess: () => {
      toast.success('Commission updated successfully');
      onSuccess?.();
      onClose?.();
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message || err?.message || 'Failed to update commission');
    }
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    const cleaned = value.replace(/[^0-9.]/g, '');
    setFormData((prev) => ({ ...prev, [name]: cleaned }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    saveCommission({
      plot_commission_charge: Number(formData.plot_commission_charge) || 0,
      unit_commission_charge: Number(formData.unit_commission_charge) || 0
    });
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-6">
      <p className="text-sm text-gray-600">
        Builder: <span className="font-medium text-gray-900">{builder?.builder_name}</span>
      </p>

      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          <label htmlFor="plot_commission_charge" className="text-gray-600">
            Plot Commission Charge
          </label>
          <input
            id="plot_commission_charge"
            name="plot_commission_charge"
            type="text"
            inputMode="decimal"
            className="w-full rounded border border-stone-300 p-2"
            value={formData.plot_commission_charge}
            onChange={handleChange}
            placeholder="Enter plot commission charge"
          />
        </div>

        <div className="flex flex-col gap-1">
          <label htmlFor="unit_commission_charge" className="text-gray-600">
            Unit Commission Charge
          </label>
          <input
            id="unit_commission_charge"
            name="unit_commission_charge"
            type="text"
            inputMode="decimal"
            className="w-full rounded border border-stone-300 p-2"
            value={formData.unit_commission_charge}
            onChange={handleChange}
            placeholder="Enter unit commission charge"
          />
        </div>
      </div>

      <div className="flex w-full items-center justify-end gap-4">
        <Button displayType="secondary" type="button" onClick={onClose}>
          Cancel
        </Button>
        <Button type="submit" disabled={isLoading}>
          {isLoading ? 'Saving...' : 'Save'}
        </Button>
      </div>
    </form>
  );
};

export default EditBuilderCommission;
